import KumosearchError from "./KumosearchError";

export default class MissingConfigurationError extends KumosearchError {}
